import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import moment from "../../common/UserMoment";
import { isUK } from "../../config/locationValidationConfig";

import "./index.css";

const Footer = () => {
  const locationLabel = process.env.REACT_APP_LOCATION_LABEL;
  
  return (
    <footer className="footer Site-footer">
      <Container>
        <Row>
          <Col sm="12">
            {/* Copyright &copy; yMantra 2021 */}
            Copyright &copy; ptMantra{isUK() && locationLabel ? ` [${locationLabel}]` : ""} {moment().format("Y")}
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
export default Footer;
